import { css } from 'lit';

export const styles = css`
  .multi-select-wrapper {
    display: flex;
    flex-direction: column;
    border: 1px solid rgb(34, 34, 34);
    width: calc(100% - calc(34rem / var(--default-rem-px-count)));
    margin: calc(20rem / var(--default-rem-px-count)) 0;
    padding: calc(4rem / var(--default-rem-px-count))
      calc(16rem / var(--default-rem-px-count));
  }

  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    color: inherit;
    text-align: left;
  }

  .header:focus-visible {
    outline: 2px solid #222222;
    outline-offset: 2px;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .filter-option label:focus-within {
    outline: 2px solid #222222;
    outline-offset: 2px;
  }

  .select-arrow {
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto 0;
    padding: 0 2px;
  }

  .arrow-closed {
    transform: rotate(90deg);
  }

  .arrow-expanded {
    transform: rotate(270deg);
  }

  .options-content,
  .options-buttons {
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: calc(15em / var(--default-rem-px-count));
    padding-bottom: calc(16rem / var(--default-rem-px-count));
  }

  .options-content .side {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .option-category-header {
    font-weight: var(--fw-medium);
    margin: calc(16rem / var(--default-rem-px-count)) 0;
  }

  .options-buttons {
    padding-top: calc(12rem / var(--default-rem-px-count));
  }

  .options-buttons cta-button {
    flex-grow: 1;
  }

  /* Checkbox visual styles live in choiceStyles (form-controls/choice-styles.js) */

  .filter-option {
    padding: calc(4rem / var(--default-rem-px-count)) 0;
  }

  .filter-option .tf-choice {
    width: 100%;
    margin-bottom: 0;
  }

  /* For iPhone, any font size < 16px will trigger a zoom that breaks the UI */
  input[type='text'] {
    font-size: max(1rem, 16px);
  }

  .input-wrapper {
    flex-grow: 1;
    position: relative;
    display: flex;
  }

  .input-wrapper.search {
    border: 1px solid var(--block-text-color, #222222);
  }

  .search input {
    width: 100%;
  }

  /* Override browser defaults */
  input {
    -webkit-appearance: none;
    outline: none;
    box-shadow: none;
    border: none;
    padding: 0;
    background: none;
  }

  input {
    height: calc(42rem / var(--default-rem-px-count));
    width: 100%;
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-left: calc(16rem / var(--default-rem-px-count));
    display: block;
  }

  .search-icon {
    padding-top: calc(4rem / var(--default-rem-px-count));
    padding-right: calc(16rem / var(--default-rem-px-count));
    height: calc(16rem / var(--default-rem-px-count));
    margin: auto;
  }

  @media (min-width: 600px) {
    input[type='text'] {
      font-size: inherit;
    }
  }
`;
